// ==============================|| OVERRIDES - INPUT LABEL ||============================== //

export default function InputLabel(theme) {
	return {
		MuiInputLabel: {
			styleOverrides: {
				root: {
					// fontSize: '0.9rem',
					// wordWrap: 'break-word',
					// color: theme.palette.text.secondary,
					// fontWeight: 400,
					// lineHeight: 1.4,
					// '&.Mui-focused': {
					// 	color: '#000000'
					// },
					// '&.Mui-error': {
					// 	color: theme.palette.error.main
					// },
				},
				standard: {
					// fontSize: '0.9rem',
					// wordWrap: 'break-word',
					// color: theme.palette.primary.darker,
					// fontWeight: 400,
					// lineHeight: 1.4,
					// '&.Mui-error': {
					// 	color: theme.palette.error.main
					// },
					// '&.Mui-focused': {
					// 	fontSize: '0.9rem',
					// 	wordWrap: 'break-word',
					// 	color: theme.palette.primary.dark,
					// 	fontWeight: 400,
					// 	lineHeight: 1.4,
					// 	'&.Mui-error': {
					// 		color: theme.palette.error.main
					// 	},
					// 	/*'&.Mui-disabled': {
					// 		color: '#F04134'
					// 	},*/
					// },
					// /*'&.Mui-disabled': {
					// 	color: '#F04134'
					// },*/
					// '&.MuiInputLabel-shrink': {
					// 	fontSize: '16px',
					// 	wordWrap: 'break-word',
					// 	color: theme.palette.primary.darker,
					// 	fontWeight: 400,
					// 	lineHeight: 1.4,
					// 	'&.Mui-error': {
					// 		color: theme.palette.error.main
					// 	},
					// 	/*'&.Mui-disabled': {
					// 		color: '#F04134'
					// 	},*/
					// 	'&.Mui-focused': {
					// 		fontSize: '16px',
					// 		wordWrap: 'break-word',
					// 		color: theme.palette.primary.dark,
					// 		fontWeight: 600,
					// 		lineHeight: 1.4,
					// 		'&.Mui-error': {
					// 			fontSize: '16px',
					// 			wordWrap: 'break-word',
					// 			fontWeight: 600,
					// 			lineHeight: 1.4,
					// 			color: theme.palette.error.main
					// 		},
					// 		/*'&.Mui-disabled': {
					// 			color: '#F04134'
					// 		},*/
					// 	},
					// },
				},
				outlined: {
					// color: theme.palette.primary.dark,
					// '&.Mui-focused': {
					// 	color: theme.palette.primary.dark,
					// 	'&.Mui-error': {
					// 		color: theme.palette.error.main
					// 	},
					// },
					// '&.Mui-disabled': {
					// 	color: theme.palette.primary.dark
					// },
				},
				filled: {
					// color: theme.palette.primary.dark,
					// '&.Mui-focused': {
					// 	color: theme.palette.primary.dark,
					// 	'&.Mui-error': {
					// 		color: theme.palette.error.main
					// 	},
					// },
					// '&.Mui-disabled': {
					// 	color: theme.palette.primary.dark
					// },
				},
				
			}
		}
	}
}